// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';
import LRU from 'lru-cache';

const cache = LRU({ max: 30 });

export const getChannelStats = wrapWithNetworkError(function getChannelStats(
  token: string,
  clientId: Id,
  channelName: string,
  worklist?: boolean
) {
  const key = [clientId, channelName, worklist].join(':');

  if (cache.has(key)) {
    const response = cache.get(key);
    if (response) return Promise.resolve(response);
  }

  const fetchUrl = getEndpointUrl(
    `/moderate/content/client/${clientId}/channelStats${
      worklist ? '/queue' : ''
    }`
  );
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
      Authorization: token,
    },

    body: JSON.stringify([channelName]),
  };

  return fetch(fetchUrl, fetchOptions)
    .then(response => checkResponse(response))
    .then(response => response.json())
    .then(response => {
      cache.set(key, response);
      return response;
    });
});

export const getbrandEngageChannelsStats = wrapWithNetworkError(
  function getBrandEngageChannelStats(
    token: string,
    brandEngageType: string,
    clientId: Id,
    channelName: string
  ) {
    const key = [clientId, channelName, brandEngageType].join(':');

    if (cache.has(key)) {
      const response = cache.get(key);
      if (response) return Promise.resolve(response);
    }

    const fetchUrl = getEndpointUrl(
      `/brand-engage/${brandEngageType}/client/${clientId}/channel/${channelName}/stats`
    );
    const fetchOptions = {
      headers: {
        Authorization: token,
      },
    };

    return fetch(fetchUrl, fetchOptions)
      .then(response => checkResponse(response))
      .then(response => response.json())
      .then(response => {
        cache.set(key, response);
        return response;
      });
  }
);



// WEBPACK FOOTER //
// ./src/containers/channels/channelStatsApi.js